// extracted by mini-css-extract-plugin
export default {"blankContainer":"BlankWorkbookCard__blankContainer___DRMKT"};